// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1XtAF","selected":"Chip_selected__4oQ9b"};